import { useHistory, useLocation } from 'react-router-dom'

export const useLateralMenu = () => {
  const history = useHistory<{ isLateralMenuVisible: boolean }>()
  const location = useLocation<{ isLateralMenuVisible: boolean }>()

  const show = () => {
    history.push(location.pathname, { isLateralMenuVisible: true })
  }

  const hide = () => {
    history.replace(location.pathname, { isLateralMenuVisible: false })
  }

  const isVisible = () => {
    return location?.state?.isLateralMenuVisible
  }

  return {
    show,
    hide,
    isVisible
  }
}
